import React, {useEffect, useState} from 'react';
import {useProviderProfile} from "../../../../ProviderProfileProvider";
import {useNavigate} from "react-router-dom";
import {useRpcSender} from "../../../../util/RpcSender";
import {
  AcceptClientInquiryRequest,
  GetClientInquiriesResponse,
  GetClientListResponse, IApiClientInquiryProto,
  IApiProviderProto,
  IClientProto
} from "../../../../provider_api";
import {RpcState} from "../../../../util/RpcState";
import {findPractitioner} from "../Calendar/CalendarUtil";
import {KensuTable} from "../../../../components/table/KensuTable";
import {TabbedPageHeader} from "../../../../components/TabbedPageHeader";
import {shortDateFormat} from "../../../../util/DateTimeUtils";

import {useNavigateWithParams} from "../../../../util/NavUtils";
import {useTeamTabs} from "../Team/TeamRouter";
import {useClientsTab} from "./ClientsRouter";
import {User} from "@auth0/auth0-react";
import {ActionButton} from "../../../../util/UI/ActionButton";

export const ClientInquiriesList = () => {

  const rpcSender = useRpcSender();
  const navigate = useNavigateWithParams();

  const [rpcState, setRpcState] = useState<RpcState>({state: "none"});

  const [inquiries, setInquiries] = useState<IApiClientInquiryProto[]>();

  useEffect(() => {

    rpcSender.send('get_client_inquiries', new Uint8Array([]))
        .then(r => {
          const response = GetClientInquiriesResponse.decode(r);
          if (!response.okay) {
            setRpcState({state: 'error', message: 'unknown error fetching login'});
            return;
          }

          setInquiries(response.inquiries);
          setRpcState({state: 'success'});

        })
        .catch(e => {
          setRpcState({state: 'error', message: e});
        })
  }, []);
  
  const handleInquiry = (userId: string, accept: boolean) => {
    
    if (!window.confirm(`Are you sure you want to ${accept ? 'accept' : 'ignore'} this inquiry?`)) {
      return;
    }
    
    const request = AcceptClientInquiryRequest.encode(new AcceptClientInquiryRequest({
      userId: userId,
      accept: accept,
    })).finish()
    
    rpcSender.send('accept_client_inquiry', request)
        .then(r => {
          const response = GetClientInquiriesResponse.decode(r);
          if (!response.okay) {
            setRpcState({state: 'error', message: 'unknown error fetching login'});
            return;
          }

          setRpcState({state: 'success'});
          
          // HACK... just reload do this to get the latest... 
          window.location.reload();

        })
        .catch(e => {
          setRpcState({state: 'error', message: e});
        })
  }
  

  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={'Clients'} tabs={useClientsTab()}/>

    <div className={'ProviderToolAreaContent'}>

      {/* TODO how to handle versioning on providers */}
      <KensuTable data={inquiries}
                  // onRowSelected={r => navigate('./' + r?.userId)} 
          columns={[
        {label: 'Name', render: row => row?.details?.inquirerName, sortString: row => row?.details?.inquirerName},
        {label: 'Email', render: row => row?.details?.inquirerEmail, sortString: row => row?.details?.inquirerEmail},
        {label: 'Message', render: row => row?.details?.message ?? '<empty>'},

        {
          label: 'Actions', render: row => {
            return <div style={{display: 'flex', gap: 10}}>
              <ActionButton smaller secondary 
                            onClick={() => handleInquiry(row.userId as string, true)}>
                Accept
              </ActionButton>
              <ActionButton smaller secondary
                            onClick={() => handleInquiry(row.userId as string, false)}>
                Ignore
              </ActionButton>
            </div>
          }
        },  
      ]}/>

      {rpcState.state == 'pending' && 'Loading...'}

      {rpcState.state == 'error' && <div className={'ErrorText'}>{rpcState.message}</div>}

      {rpcState.state == 'success' && !inquiries?.length && <div>
        <br/><br/>
        There aren't any outstanding inquiries.
      </div>}

    </div>
  </div>
};

